// extracted by css-extract-rspack-plugin
export default {"FilterFooterRoot":"Q3RiF"};